import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    wrapper: css({
        width: '100%',
        marginTop: '30px',
        ...(isHosTheme && {
            marginBottom: '10px',
        }),
    }),
    title: css({
        display: 'flex',
        flexDirection: 'row',
    }),
    astericks: css({
        color: theme.palette.primary.main,
        marginLeft: '5px',
    }),
};
